module.exports = __webpack_public_path__ + "static/media/DT4.03e0f7aa.jpg";